import { SharingTipRecipientInfo } from '../../types/SharingTipRecipientInfo';
import { LARGE_DL_MEMBER_COUNT } from '../constants';
import { isDLOrGroup } from './isDLOrGroup';

export function getGroupsAndSmallDLs(
    recipientInfo: SharingTipRecipientInfo[]
): SharingTipRecipientInfo[] {
    return recipientInfo.filter(
        info =>
            info.totalMemberCount <= LARGE_DL_MEMBER_COUNT &&
            isDLOrGroup(info.recipient.persona.EmailAddress.MailboxType)
    );
}
